import React, { useEffect, useRef, useState } from "react";
import { Form, Spin, Select, Modal, DatePicker, Input, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import Dragger from "antd/es/upload/Dragger";
import { save, uploadFile } from "../../../../features/save/saveSlice";

const url = process.env.REACT_APP_API_BASE_URL;
const DocumentAdd = ({
  isModalOpen,
  handleCancel,
  handleFetch,
  prodd,
  prodd1,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { activeObjPlannedProject } = useSelector((state) => ({
    activeObjPlannedProject: state.obj.activeObj["plannedProject"],
  }));
   const {iwuaLicenses} =  useSelector((state)=>state.fetch)

  
  const [fileUrl, setfileUrl] = useState("");
  const [fileName, setfileName] = useState("");
  const [fileLoading, setFileLoading] = useState(false);
  const props = {
    name: "file",
    multiple: false,
    accept: "*",
    showUploadList: true,

    beforeUpload: async (file) => {
      // const isGt10MB = file.size / 1024 / 1024 > 10;

      // if (isGt10MB) {
      //   toast.error("File must be smaller than 10MB!");
      //   return;
      // }

      setFileLoading(true);

      const formData = new FormData();
      formData.append("file", file);

      try {
        const res = await dispatch(uploadFile(formData)).unwrap();
        if (res?.success) {
          toast.success(`${file.name} file attached successfully.`);
          setfileUrl(res?.data?.result);
          setfileName(file.name);
        } else {
          message.error(`Upload failed: ${res.message}`);
          setfileUrl("");
          setfileName("");
        }
      } catch (err) {
        message.error(`Upload failed`);
        console.error(err);
      } finally {
        setFileLoading(false);
      }

      return false;
    },

    onDrop(e) {
      setFileLoading(false);
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  const onFinish = async (data) => {
    if (!fileUrl) {
      toast.error("Please upload file");
      return;
    }
    const res = await dispatch(
      save({
        pfFilePath: fileUrl,
        pfProjectId: activeObjPlannedProject?.projectId, 
        pfFileCategory: "LICENCING", 
        pfFileName: data?.pfFileName,
        url: "api/v2/projectFiles/save",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await handleFetch();
      await form.resetFields();
      await handleCancel();
    } else {
      toast.error(res?.payload?.message);
    }
  };
 
  return (
    <Modal
      title={`${prodd?.usrId ? "Update Document" : `Upload Document`}`}
      open={isModalOpen}
      onOk={onFinish}
      onCancel={handleCancel}
      className="!w-[49.5rem]"
      maskClosable={false}
    >
      <Form
        layout="vertical"
        ref={formRef}
        name="control-ref"
        onFinish={onFinish}
        className=""
        style={{
          maxWidth: "100%",
        }}
        form={form}
      >
        <Form.Item
          name="pfFileName"
          className=""
          label={"Document Name"}
          rules={[
            {
              required: true,
              message: "Please add document name",
            },
          ]}
        >
          <Input className="input" />
        </Form.Item>
 
        <Form.Item
          name=""
          label="Document File"
          rules={[
            {
              required: true,
              message: "Please upload a file",
            },
          ]}
        >
          <Dragger className="attachment" {...props}>
            <div className="flex flex-col justify-center">
              <div className="flex justify-center mb-5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  fill="none"
                >
                  <path
                    d="M25.375 18.125V22.9583C25.375 23.5993 25.1204 24.214 24.6672 24.6672C24.214 25.1204 23.5993 25.375 22.9583 25.375H6.04167C5.40073 25.375 4.78604 25.1204 4.33283 24.6672C3.87961 24.214 3.625 23.5993 3.625 22.9583V18.125"
                    stroke="#147CBC"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M20.5423 9.66667L14.5007 3.625L8.45898 9.66667"
                    stroke="#147CBC"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.5 3.625V18.125"
                    stroke="#147CBC"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <p className="ant-upload-text !ml-2">
                Click to upload
                <span className="ml-2 text-[#667085]">or drag and drop</span>
                <br></br>
                <span className="!mt-[10rem] text-[#667085]">
                  PNG or JPG (max. 800x400px)
                </span>
              </p>
            </div>
          </Dragger>
        </Form.Item>

        <div className="flex justify-between mt-[48px] ">
          <div className="justify-start"></div>
          <div className="justify-end flex items-center mb-[58px] gap-x-5">
            <div className="w-[150px]">
              <button
                type="button"
                key="back"
                onClick={handleCancel}
                className="cstm-btn"
              >
                Cancel
              </button>
            </div>

            <div className="w-[150px]">
              <button
                disabled={saving}
                key="submit"
                type="submit"
                className="cstm-btn-2"
              >
                {saving ? <Spin /> : prodd?.usrId ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
};
export default DocumentAdd;
